import { PageHero } from '@/components/page-hero'
import { T } from '@/components/t'

export const PricingHeader = () => {
    return (
        <PageHero
            title={<T span t={'pricing.hero.title'} />}
            description={<T span t={'pricing.hero.description'} />}
        />
    )
}
